import type { LinkTag } from 'next-seo/lib/types';
import {
  apikUrl,
  appAssetsCdnUrl,
  blobCdnUrl,
  vexCdnUrl
} from '~/constants/environment';

export const PRECONNECT_LINKS: LinkTag[] = [
  {
    rel: 'preconnect',
    href: apikUrl
  },
  {
    rel: 'preconnect',
    href: appAssetsCdnUrl
  },
  {
    rel: 'preconnect',
    href: blobCdnUrl
  },
  {
    rel: 'preconnect',
    href: vexCdnUrl
  }
];
